import React, { useState } from "react";

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert(`Thank you, ${formData.name}! Your message has been sent.`);
    setFormData({ name: "", email: "", message: "" });
  };

  return (
    <main className="pt-24 max-w-5xl mx-auto px-6">
      <h2 className="text-4xl font-bold text-brand-red mb-6">Contact Us</h2>
      <p className="text-lg text-gray-700 leading-relaxed mb-12">
        Have questions about our products or want to place a custom order? 
        We’d love to hear from you! Use the form below, or reach out directly.
      </p>

      {/* Contact Form */}
      <form
        onSubmit={handleSubmit}
        className="bg-gray-100 p-6 rounded-lg shadow-md space-y-4"
      >
        <div>
          <label className="block font-semibold mb-1">Name</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
            className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-brand-red"
          />
        </div>

        <div>
          <label className="block font-semibold mb-1">Email</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
            className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-brand-red"
          />
        </div>

        <div>
          <label className="block font-semibold mb-1">Message</label>
          <textarea
            name="message"
            value={formData.message}
            onChange={handleChange}
            required
            rows="5"
            className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-brand-red"
          ></textarea>
        </div>

        <button
          type="submit"
          className="px-6 py-3 bg-brand-red text-white font-semibold rounded-lg shadow hover:bg-brand-navy transition"
        >
          Send Message
        </button>
      </form>

      {/* Or give us a call */}
      <p className="text-center text-lg text-gray-700 mt-8">
        Or give us a call at{" "}
        <a href="tel:4326873400" className="text-brand-red font-bold hover:underline">
          (432) 687-3400
        </a>
      </p>

      {/* Logo at bottom */}
      <div className="flex justify-center mt-20">
        <img
          src="/logo.png"
          alt="Texana Trading Co."
          className="h-64 w-auto animate-fadeIn"
        />
      </div>
    </main>
  );
}

export default Contact;